import * as React from "react";
type Props = {
  className?: string,
};
function SvgSwirl({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-swirl"
      className={className}
    >
      <path
        d="M6 12.0005C6 8.13417 9.13406 5 13 5C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3C8.02938 3 4 7.02972 4 12.0005C4 16.9712 8.02937 21.001 13 21.001C16.8447 21.001 20 17.9476 20 14.134C20 10.3204 16.8447 7.26693 13 7.26693C10.3046 7.26693 8 9.32241 8 12.0005C8 14.6773 10.3024 16.7321 12.9962 16.7341L13 16.7341C14.7168 16.7341 16 15.2694 16 13.6006C16 11.9319 14.7168 10.4671 13 10.4671C12.4477 10.4671 12 10.9149 12 11.4671C12 12.0194 12.4477 12.4671 13 12.4671C13.4924 12.4671 14 12.9128 14 13.6006C14 14.2885 13.4924 14.7341 13 14.7341C11.2771 14.7341 10 13.4464 10 12.0005C10 10.5546 11.2771 9.26693 13 9.26693C15.7827 9.26693 18 11.467 18 14.134C18 16.801 15.7827 19.001 13 19.001C9.13407 19.001 6 15.8668 6 12.0005Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgSwirl;
